import {
  CHART_REPLACED,
  CHART_PAID_OFF,
  CHART_GREEN,
  CHART_GREY,
  CHART_CANCELLED,
  CHART_INACTIVE,
  CHART_GOLD,
  CHART_DEFAULT,
} from "../../../lib/constants";
import { useState, useEffect, useCallback } from "react";
import { KPI_CODES } from "../kpiCodes";

export const useGetDashboardData = (data: any) => {
  const getValueByCode = useCallback(
    (code: string) => {
      return data.kpiValues.find((item: any) => item.code === code)?.value;
    },
    [data],
  );

  const [opened, setOpened] = useState<any>(null);

  const [closed, setClosed] = useState<any>(null);

  const [other, setOther] = useState<number | null>(null);

  const [draft, setDraft] = useState<number | null>(null);

  const parseData = useCallback(() => {
    const openedValue = [
      {
        type: "Active",
        color: CHART_GREEN,
        value: getValueByCode(KPI_CODES.ACCOUNTS_ACTIVE),
      },
      {
        type: "Inactive",
        color: CHART_INACTIVE,
        value: getValueByCode(KPI_CODES.ACCOUNTS_INACTIVE),
      },
      {
        type: "Semi-active",
        color: CHART_GOLD,
        value: getValueByCode(KPI_CODES.ACCOUNTS_SEMIACTIVE),
      },
    ];

    setOpened({
      values: openedValue,
      colors: [CHART_GREEN, CHART_INACTIVE, CHART_GOLD],
    });

    const closedValue = [
      {
        type: "Paid Off",
        color: CHART_PAID_OFF,
        value: getValueByCode(KPI_CODES.ACCOUNTS_PAYDOFF),
      },
      {
        type: "Archived",
        color: CHART_GREY,
        value: getValueByCode(KPI_CODES.ACCOUNTS_ARCHIVED),
      },
      {
        type: "Default",
        color: CHART_DEFAULT,
        value: getValueByCode(KPI_CODES.ACCOUNTS_DEFAULT),
      },
      {
        type: "Cancelled",
        color: CHART_CANCELLED,
        value: getValueByCode(KPI_CODES.ACCOUNTS_CANCELED),
      },
      {
        type: "Replaced",
        color: CHART_REPLACED,
        value: getValueByCode(KPI_CODES.ACCOUNTS_REPLACED),
      },
    ];

    setClosed({
      values: closedValue,
      colors: [
        CHART_PAID_OFF,
        CHART_GREY,
        CHART_DEFAULT,
        CHART_CANCELLED,
        CHART_REPLACED,
      ],
    });

    const otherValue = getValueByCode(KPI_CODES.ACCOUNTS_OTHER);

    const draftValue = getValueByCode(KPI_CODES.ACCOUNTS_DRAFT);

    setOther(otherValue);
    setDraft(draftValue);
  }, [getValueByCode]);

  useEffect(() => {
    if (data) {
      parseData();
    }
  }, [data, parseData]);

  return [opened, closed, other, draft];
};
